<template>
  <thead>
    <tr>
      <td :colspan="colspan">
        <div
          v-if="dateISO !== 'no-date'"
          class="head-row grid grid_h-between grid_v-center"
          :class="{'head-row_first' : index === 0}"
        >
          <div class="grid__col grid__col_auto">
            <b>{{ formatDate(dateISO) }}</b>
          </div>
          <!-- временно скрыл погоду -->
          <!-- <div class="grid__col grid__col_auto">
            <weather-badge
              v-if="event && event.BeginDate"
              slot="right"
              :lat="event.lat"
              :lon="event.lon"
              :date="dateISO"
              :timezone="event.TimeZoneOffset"
              size="sm"
            />
          </div> -->
        </div>
      </td>
    </tr>
  </thead>
</template>

<script>
// import WeatherBadge from '@/components/WeatherBadge.vue';

export default {
  name: 'EventRacesHeadRow',
  props: {
    colspan: {
      type: Number,
      default: 4,
    },
    dateISO: {
      type: String,
    },
    index: {
      type: Number,
    },
    event: {
      type: Object,
    },
  },
  /*
  components: {
    WeatherBadge,
  },
  */
  methods: {
    formatDate(date) {
      const locale = this.$lang === 'uz' ? 'uz-latn' : this.$lang;
      const d = this.$moment(date).locale(locale);
      let day = d.format('dd');
      day = day[0].toUpperCase() + day.slice(1).toLowerCase();

      return d.format(`[${day}] [•] DD MMMM`);
    },
  },
};
</script>

<style lang="scss" scoped>
.head-row {
  display: flex;
  align-items: center;
  height: 32 + 12 + 12px;
  background-color: $color-white;
  margin-bottom: -12px;

  &_first {
    margin-top: -12px;
  }
}
</style>
